<template>
  <validation-observer
    ref="observer"
    v-slot="{ handleSubmit }">
    <form
      class="final-destination-form"
      @submit.prevent="handleSubmit(onSubmit)">
      <validation-provider
        v-slot="{ errors }"
        name="user"
        rules="required">
        <input
          v-model="value.user"
          class="d-none"
          type="text">
      </validation-provider>
      <validation-provider
        v-slot="{ errors }"
        name="最終進学先"
        vid="destinationName"
        rules="max:64">
        <b-form-input
          v-model="value.destinationName"
          type="text"
          class="event-form__title-input"
          placeholder="最終進学先を入力してください"
          hide-header />
        <p class="text-primary">
          {{ errors[0] }}
        </p>
      </validation-provider>
      <div
        class="d-flex justify-content-between mt-4"
        style="gap: 16px;">
        <button
          type="button"
          class="btn btn-block btn-cancel"
          @click="onClickCancel">
          キャンセル
        </button>
        <button
          type="submit"
          class="btn btn-block btn-primary mt-0">
          保存
        </button>
      </div>
    </form>
  </validation-observer>
</template>

<script>
export default {
  props: {
    finalDestination: {
      type: Object,
      default: null,
    },
    user: {
      type: String,
      required: true,
    },
    apiErrors: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      value: {
        user: this.user,
        destinationName: '',
      },
    }
  },
  watch: {
    apiErrors(val) {
      if (val) {
        this.$refs.observer.setErrors(val)
      }
    }
  },
  created() {
    if (this.finalDestination) {
      this.value.destinationName = this.finalDestination.destinationName
    }
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.value)
    },
    onClickCancel() {
      this.$router.back()
    },
  },
}
</script>

<style>

</style>